import { render, staticRenderFns } from "./global-notification.vue?vue&type=template&id=ec8ef71e&scoped=true"
import script from "./global-notification.vue?vue&type=script&lang=ts"
export * from "./global-notification.vue?vue&type=script&lang=ts"
import style0 from "./global-notification.vue?vue&type=style&index=0&id=ec8ef71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8ef71e",
  null
  
)

export default component.exports